import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Home, Truck } from 'lucide-react';

const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 pt-20" data-testid="not-found-page">
    <div className="text-center max-w-md">
      <p className="text-7xl font-black text-green-600 mb-4">404</p>
      <h1 className="text-3xl font-bold text-gray-900 mb-3">Page introuvable</h1>
      <p className="text-gray-600 mb-8">
        La page que vous cherchez n'existe pas ou a été déplacée.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/" data-testid="not-found-home-link">
          <Button className="bg-green-600 hover:bg-green-700 w-full sm:w-auto">
            <Home className="w-4 h-4 mr-2" /> Retour à l'accueil
          </Button>
        </Link>
        <Link to="/commander-sans-compte" data-testid="not-found-order-link">
          <Button variant="outline" className="w-full sm:w-auto">
            <Truck className="w-4 h-4 mr-2" /> Commander une benne
          </Button>
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
